module.exports = __webpack_public_path__ + "static/media/Aquaponics.591e070f.webp";